import { render, staticRenderFns } from "./BlogsSnippet.vue?vue&type=template&id=28e9c85c&"
import script from "./BlogsSnippet.vue?vue&type=script&lang=js&"
export * from "./BlogsSnippet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports